import { useState } from 'react';
import { FcGoogle } from 'react-icons/fc';

import useStateHandler from '@/hooks/useStateHandler';
import { signInWithGoogle } from '@/services/firebase.service';
import { exchangeGoogleUserForSession } from '@/services/google-auto-flow.service';
import MandatoryPopupResultsService from '@/services/mandatoryPopupResults.service';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import './styles/AuthGoogle.css';

export default function AuthGoogle({
  close,
  className = '',
  textButton = 'Continue with Google',
  resultType = 'login_success_google',
}) {
  const { stateHandler, state } = useStateHandler();
  const [loading, setLoading] = useState(false);

  const googleHandler = async () => {
    setLoading(true);
        
    console.info("[AuthGoogle] CLICK Google, starting signInWithGoogle");
    const firebaseResponse = await signInWithGoogle();
    console.info("[AuthGoogle] signInWithGoogle response", firebaseResponse);

    // Redirect in progress (native app / popup blocked)
    if (firebaseResponse.code === "auth/redirect-in-progress") {
      console.info("[AuthGoogle] Google redirect in progress", firebaseResponse);
      setLoading(false);
      return;
    }

    if (firebaseResponse.code) {
      console.info("[AuthGoogle] Firebase returned code, stopping flow", firebaseResponse.code);
      console.error("[AuthGoogle] Google sign-in failed", firebaseResponse);
      alert("We couldn’t start Google sign-in. Please try again later.");
      setLoading(false);
      return;
    }

    const loginResult = await exchangeGoogleUserForSession({
      firebaseUser: firebaseResponse.user,
      inviteCode: state.invite,
      stateHandler,
      setLoading,
    });

    if (!loginResult.ok) {
      if (loginResult.reason === "email-belongs-to-artist") {
        alert("This email is already associated with an artist");
      } else {
        alert("We could not complete your sign in. Please try again.");
      }
      setLoading(false);
      return;
    }

    const data = loginResult.data;
    const isNewUser = Boolean(data?.meta?.isNewUser);
    const analyticsResult = isNewUser ? "signup_success_google" : resultType || "login_success_google";
    if (analyticsResult) {
      MandatoryPopupResultsService.createMandatoryPopupResult(
        { result: analyticsResult },
        { useStoredContext: true, clearStoredContext: true }
      ).catch((error) => {
        console.error('Failed to persist mandatory popup google success', error);
      });
    }
    close();
  };

  return (
    <>
      <button className={`auth-google__button ${className} ${loading ? "disabled" : ""}`} onClick={googleHandler}> 
        <FcGoogle className="auth-google__icon"/>
        <Text className="auth-google__text font-size-small">{textButton}</Text>
        {loading && <Loader inline className="auth-google__spinner" thin/>}
      </button>
    </>
  );
}
